<template>
  <div id="day-off-list" style="position: relative;">
    <!-- Spinner -->
    <loading :active.sync="loading" :is-full-page="false"></loading>
    <!--/Spinner-->

    <!-- User 선택-->
    <b-form @submit.prevent ref="form">
      <div class="user-form">
        <label for="assignee-list">User</label>
        <!-- User -->
        <b-form-select id="assignee-list" size="sm" v-model="filter.assignee"
          :options="reformatedAssignees()"></b-form-select>
      </div>
    </b-form>

    <!-- Day Off List 테이블-->
    <template v-if="dayOffList.length > 0">
      <div class="table-container">
        <table class="table">
          <colgroup>
            <col width="104px">
            <col width="92px">
            <col width="140px">
            <col width="75px">
            <col width="77px">
          </colgroup>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Hours</th>
              <th>Message</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dayOff, idx) in dayOffList">
              <!-- 한 날짜에 휴가인 사람이 여러명이면 날짜 행 병합-->
              <td v-if="idx == 0 || dayOff.date != dayOffList[idx - 1].date" :rowspan="getDayOffRowSpan(dayOff, dayOffList)">
                {{ dayOff.date }}</td>
              <td> {{ dayOff.userName }} </td>
              <td> {{ dayOff.hour }} </td>
              <td> {{ dayOff.reason }} </td>
              <td> <i v-if="dayOff.userId == currentUser.caller" class="btn-delete" type="button"
                  v-on:click="removeDayOff(dayOff.userId, dayOff.date)"></i> </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <div class="table-container">
        <div class="table-scroll">
          <table class="table">
            <b-tr class="btn-primary">
              <b-th v-for="field in fields">{{ field.label }}</b-th>
            </b-tr>
            <b-tr>
              <b-td colspan="5">
                결과가 없습니다.
              </b-td>
            </b-tr>
          </table>
        </div>
      </div>
    </template>

    <!-- Card Footer -->
    <div class="dayoff-pagination">
      <b-pagination class="mb-0" v-model="pageInfo.curr" :total-rows="pageInfo.total" :per-page="pageInfo.perPage"
        :limit="7" text-align="center"></b-pagination>
    </div>
    <!-- Add My Day Off-->
    <div v-if="filter.assignee == currentUser.caller" class="dayoff-field-wrap">
      <p class="calendar-sub-title">Add My Day Off</p>
      <b-form @submit.prevent ref="form">
        <div class="dayoff-field d-flex">
          <b-col>
            <label for="dayOffStartDate">Date<span class="required"></span></label>
            <b-input-group class="form-inline date">
              <b-form-input id="dayOff" name="dayOff" v-validate="{ required: true }" type="text"
                                v-model="dayOff.dayOffDate" class="custom-input" placeholder="YYYY-MM-DD"
                                size="sm">
              </b-form-input>
              <b-input-group-append>
                <b-form-datepicker id="date-picker" placeholder="YYYY-DD-MM" v-model="dayOff.dayOffDate" button-only right></b-form-datepicker>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col>
            <label for="dayOffHours">Hours<span class="required"></span></label>
            <b-input-group class="input-date">
              <b-form-input id="dayOffHours" name="dayOffHours" type="text" v-model="dayOff.hours"
                class="custom-input rounded" v-b-popover.hover.bottom="'Day Off Hour range should be between 1 to 9'">
              </b-form-input>
            </b-input-group>
          </b-col>
        </div>
        <div class="dayoff-field">
          <b-col>
            <label for="dayOffMessage">Message</label>
            <b-input-group class="form-inline">
              <b-form-input id="dayOffMessage" name="message" type="text" v-model="dayOff.message"
                class="custom-input rounded">
              </b-form-input>
            </b-input-group>
          </b-col>
        </div>
        <b-button class="btn-primary" type="submit" @click="addDayOff">
          Add
        </b-button>
      </b-form>
    </div>
  </div>
</template>
  
<script>
import Loading from 'vue-loading-overlay';
import accessToken from "@/services/accessToken";
import axios from 'axios';
import 'moment/locale/ko';
import { required } from "vee-validate/dist/rules.esm";

export default {
  name: "ChatterDayOff",
  components: { Loading },
  mounted() {
    //this.retrieveDayOffList();
  },
  created() {
    /** 23-10-11 
     * Chatter Top Bar에서 최초 dispatch 하고
     * 이후 부터는 중앙 저장소에서 가져오는 식으로 변경
     *  */
    // this.$store.dispatch('chatter/retrieveProjectOptions');
    this.$store.dispatch('chatter/retrieveAssigneeOptions');
    //default로 본인의 day off를 먼저 보여주기 위함 -> filter에 본인 id를 assignee로 등록 => filter에 본인이 기본적으로 선택되어있도록
    this.$store.commit('chatter/setFilterAssignee', this.currentUser.caller);
    this.retrieveDayOffList(true);
  },
  computed: {
    required() {
      return required;
    },
    filter() {
      return this.$store.getters['chatter/filter'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    assignees(){
      return this.$store.getters['chatter/assignees'];
    }
  },
  watch: {
    'pageInfo.curr'() {
      this.retrieveDayOffList(true);
    },
    'filter.assignee'() {
      this.retrieveDayOffList(true);
    }
  },
  data() {
    return {
      loading: false,
      dayOffList: [],
      fields: [
        {
          key: 'date',
          label: 'Date'
        },
        {
          key: 'userName',
          label: 'Name'
        },
        {
          key: 'hour',
          label: 'Hours'
        },
        {
          key: 'reason',
          label: 'Message'
        },
        {
          key: "Del",
          label: "Delete"
        }
      ],
      pageInfo: {
        curr: 1,
        perPage: 18,
        total: null,
        searchName: null,
        startDate: null,
        endDate: null
      },
      dayOff: {
        dayOffDate: null,
        hours: 8,
        reason: ""
      },
      holidayList: [],
      userDayOffList: [],
    }
  },
  methods: {
    // 2023-12-14 Yunji Kim
    /* 기존에는 Vuex의 options을 이용해서 Vuex에서 assigneeOptions를 {text: '', value:''} 형태로 변경했음.
       이 로직을 Vuex에서 분리하고, View는 Vuex에서는 필요한 데이터만 가져오고 조작은 View에서 하기 위해서 아래와 같이 로직을 수정함.
    */
    reformatedAssignees(){
      //Vuex의 assignees 데이터를 {text: 이름(이메일), value: userId} 형태로 변경
      let assignees = this.assignees.map(object => {
        return {
          value : object.userId,
          text : object.userName + ' (' + object.userId + ')',
        };
      });
      let allOption = { value: "", text: "All Users" };
      return [allOption, ...assignees];
    },
    async retrieveDayOffList(isSearch = false) {
      try {
        this.loading = true;

        // 검색인 경우 초기화 안함
        if (!isSearch) {
          this.pageInfo.startDate = null;
          this.pageInfo.endDate = null;
          this.filter.assignee = '';
        }

        // Construct query parameters
        let params = {};
        // Page Information
        params.pageNum = this.pageInfo.curr;
        params.pageSize = this.pageInfo.perPage;
        params.fromDate = this.pageInfo.startDate;
        params.toDate = this.pageInfo.endDate;

        if (this.filter.assignee) {
          params.userId = this.filter.assignee;
        }
        const response = await axios.get("chatter/retrieveDayOff", {
          params,
          headers: {
            'Accept': 'application/json',
            'Authorization': accessToken()
          }
        });
        this.dayOffList = response.data.list;
        this.pageInfo.total = response.data.total;
      } catch (error) {
        // this.showError(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    // dayOff form value 초기화
    resetDayOff(dayOffDate) {
      this.dayOff.dayOffDate = dayOffDate;
      this.dayOff.hours = 8;
      this.dayOff.reason = null;
    },
    reload() {
      this.dayOffList = [];
      //상태 초기화
      this.setDefaultDayOff();
    },
    async removeDayOff(userID, dayOffDate) {
      let confirmed = await this.$bvModal.msgBoxConfirm(`${dayOffDate} :  휴일 정보를 삭제하시겠습니까?`, { title: "Confirm" });
      if (!confirmed) return;
      try {
        this.loading = true;
        const response = await axios.post("chatter/removeDayOff/", {}, {
          params: {
            'userId': userID,
            'date': dayOffDate
          },
          headers: {
            'Accept': 'application/json',
            Authorization: accessToken()
          }
        })
        this.reload();
        //ChatteMainCalendar.vue reload emit
        this.$emit("sendIsDayOffUpdated", true);

      } catch (error) {
        this.loading = false;
        this.showError(error);

      } finally {
        this.loading = false;
      }
    },
    async showError(error) {
      if (error instanceof Error && error.cause === 400) {
        return;
      }
      if (process.env.NODE_ENV === 'development') {
        console.dir(error);
      }
      await this.showMessage(error.message);
      if (error.redirectTo) {
        this.pushRoute(error.redirectTo);
      }
    },
    async addDayOff() {
      try {
        this.loading = true;
        const response = await axios.post("chatter/addDayOff", {}, {
          params: {
            "date": this.dayOff.dayOffDate,
            "hour": this.dayOff.hours,
            "reason": this.dayOff.message,
          },
          headers: {
            "Content-Type": 'application/json',
            Authorization: accessToken()
          }
        });
        let showMsg = "";
        if (response.data.status == "101") {
          this.showError(response.data.message);
          showMsg = response.data.message;
        } else {
          showMsg = this.dayOff.dayOffDate + " 일자 정상 등록 완료 ";
        }
        this.loading = false;
        await this.showMessage(showMsg);
        this.resetDayOff(this.dayOff.dayOffDate);
        this.reload();

        //ChatteMainCalendar.vue reload emit
        this.$emit("sendIsDayOffUpdated", true);

      } catch (error) {
        this.showError(error);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    //day off 테이블 출력에서 row span 계산하는 함수(All Users인 경우 같은 날짜는 Date 칸 합치기 위함)
    getDayOffRowSpan(data, arr) {
      var rowNum = 0;
      arr.forEach(item => {
        if (item.date == data.date) {
          rowNum++;
        }
      });
      return rowNum;
    },
    //dayOff의 default: 본인의 day off 리스트 보여줌, add my day off 화면 보여줌
    setDefaultDayOff(){
      //default로 본인의 day off를 먼저 보여주기 위함 -> filter에 본인 id를 assignee로 등록 => filter에 본인이 기본적으로 선택되어있도록
      this.$store.commit('chatter/setFilterAssignee', this.currentUser.caller);
      this.retrieveDayOffList(true);
      this.pageInfo.curr=1;
    }
  }
}

</script>
<style>
.table td {
  vertical-align: middle;
}

#day-off-list .card-footer {
  position: sticky;
  left: 0;
  bottom: 0;
  background-color: #f8f8f8;
}

.card-day-off {
  font-size: 10pt;
}

.customTable>tbody>tr>td:nth-child(2) {
  padding: 0;
}

.customTable>tbody>tr>td:nth-child(2)>div {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.75rem 0;
}

.customTable>tbody>tr>td:nth-child(2)>div:nth-child(1) {
  border-bottom: 1px solid #dee2e6;
}

/* 퍼블리싱 신규 작성 스타일 */
.user-form label {
  padding-left: 0.4rem;
  margin-bottom: 0.333rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}
.user-form .custom-select {
  height: 40px;
  padding: 8px 42px 8px 16px;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.833 7.5L9.99967 13.3333L4.16634 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: right 12px center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}
.user-form .custom-select:focus {
  box-shadow: none;
  border-color: unset;
}
.calendar-wrap .content-right .table-container {
  position: relative;
  padding: 1px;
  margin-top: 1.066rem;
  overflow-x: auto;
  overflow-y: hidden;
	-ms-overflow-style: none;
	transform: translate(0, 0);
}
.calendar-wrap .content-right .table-container::-webkit-scrollbar {
  width: 100%;
  height: 16px;
  background-color: #F6F6FA;
}
.calendar-wrap .content-right .table-container::-webkit-scrollbar-track {
  width: 100%;
  height: 6px;
  background-color: #E7E7EE;
  background-clip: padding-box;
  border-top: 10px solid transparent;
}
.calendar-wrap .content-right .table-container::-webkit-scrollbar-thumb {
  height: 6px;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  background-color: #747480;
}
.calendar-wrap .content-right .table-container .table {
  position: relative;
  min-width: calc(100% - 2px);
  box-sizing: border-box;
  border-collapse: collapse;
  border-style: hidden;
  border-spacing: 0;
  white-space: nowrap;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #DDDDE3;
  border-color: unset;
  overflow: hidden;
}
.calendar-wrap .content-right .table-container .table thead {
  background-color: #DDDDE3;
  color: #2E2E38;
}
.calendar-wrap .content-right .table-container .table thead th,
.calendar-wrap .content-right .table-container .table th {
  padding: 0.4rem;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 700;
  line-height: 150%;
  border: none;
  border-color: unset;
}
.calendar-wrap .content-right .table-container .table thead th:first-child {
  border-radius: 10px 0 0 0;
}
.calendar-wrap .content-right .table-container .table thead th:last-child {
  border-radius: 0 10px 0 0;
}
.calendar-wrap .content-right .table-container .table tr.btn-primary {
  background: #DDDDE3;
  border-color: unset;
  color: #2E2E38;
}
.calendar-wrap .content-right .table-container .table td {
  padding: 0.4rem 0.666rem;
  vertical-align: middle;
  border-top: 1px solid #E7E7EE;
  background-color: #FFF;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
}
.calendar-wrap .content-right .table-container .table td .btn-delete {
  position: relative;
  width: 20px;
  height: 20px;
  padding: 6px;
  border-radius: 4px;
  background-color: #747480;
  vertical-align: middle;
}
.calendar-wrap .content-right .table-container .table td .btn-delete::after {
  content: '';
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 8px;
  height: 2px;
  background-color: #FFF;
}
.dayoff-pagination {
  margin-top: 1.333rem;
}
.dayoff-pagination > ul {
  justify-content: center;
}
.dayoff-pagination .page-link {
  width: 24px;
  height: 24px;
  padding: 3px 8px;
  margin-left: 0;
  color: #2E2E38;
  text-align: center;
  font-family: 'NanumGothic';
  font-size: 12px;
  font-weight: 500;
  line-height: 150%;
  background-color: transparent;
  border: none;
  border-radius: 50px;
}
.dayoff-pagination .page-item.active .page-link {
  background-color: #2E2E38;
  border-color: unset;
  box-shadow: none;
  color: #FFF;
  font-weight: 700;
}
.dayoff-pagination .page-link:hover {
  background-color: transparent;
  border-color: unset;
  box-shadow: none;
  color: #2E2E38;
}
.dayoff-pagination .page-item.disabled .page-link {
  color: #C4C4CD;
  background-color: transparent;
  border-color: unset;
}
.dayoff-field-wrap {
  margin-top: 2.666rem;
}
.dayoff-field-wrap .calendar-sub-title {
  padding: 0 0 0.533rem 0;
  margin-bottom: 1.6rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 16px;
  font-weight: 700;
  line-height: 150%;
  border-bottom: 1px solid #DDDDE3;
}
.dayoff-field-wrap .dayoff-field {
  gap: 0 0.8rem;
}
.dayoff-field-wrap .dayoff-field + .dayoff-field {
  margin-top: 1.066rem;
}
.dayoff-field-wrap .dayoff-field .col {
  padding: 0;
}
.dayoff-field-wrap .form-inline.date input.form-control {
  padding-right: 2rem;
}
.dayoff-field-wrap .form-inline.date input.form-control:focus {
  box-shadow: none;
  border-color: unset;
}
.dayoff-field-wrap .form-inline.date .input-group-append > div > .btn {
  position: absolute;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  font-size: 0;
  background-color: #FFF;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none"><path d="M3.83398 6.66675H17.1673" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.334 3.33325H4.66732C4.20708 3.33325 3.83398 3.70635 3.83398 4.16659V15.8333C3.83398 16.2935 4.20708 16.6666 4.66732 16.6666H16.334C16.7942 16.6666 17.1673 16.2935 17.1673 15.8333V4.16659C17.1673 3.70635 16.7942 3.33325 16.334 3.33325Z" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.834 1.66675V3.33341" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.16602 1.66675V3.33341" stroke="%23C4C4CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-size: 20px 20px;
  background-repeat: no-repeat;
  border: none;
  z-index: 10;
}
.dayoff-field-wrap .form-inline.date .input-group-append > div > .btn:focus {
  box-shadow: none;
}
.dayoff-field-wrap .dayoff-field .col label {
  padding-left: 0.4rem;
  color: #2E2E38;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 700;
  line-height: 150%;
}
.dayoff-field-wrap .dayoff-field .col label .required {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #F00;
  margin-left: 2px;
  transform: translateY(-6px);
}
.dayoff-field-wrap .dayoff-field .input-group > .form-control {
  background-color: #FFF;
}
.dayoff-field-wrap .dayoff-field .input-group > .form-control:focus {
  box-shadow: none;
  border-color: unset;
}
.dayoff-field-wrap .dayoff-field + .btn-primary {
  width: 100%;
  margin-top: 1.066rem;
  border-radius: 10px;
  background-color: #2E2E38;
  color: #FFF;
  font-family: 'NanumGothic';
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  border: none;
}
.dayoff-field-wrap .dayoff-field + .btn-primary:not(:disabled):not(.disabled):active {
  background-color: #2E2E38;
  border-color: unset;
}
.dayoff-field-wrap .dayoff-field + .btn-primary:focus {
  background-color: #2E2E38;
  box-shadow: none;
  border: none;
}
</style>

<style scoped>
/* import font */
@import url('https://hangeul.pstatic.net/hangeul_static/css/nanum-gothic.css');
</style>